<template>
  <div class="trainingCompanies-list">
    <div class="sec-wrapper d-flex align-items-center mb-4">
      <h2 id="famous-companies " class="section-title">جهات التدريب</h2>
      <div class="blue-line"></div>
    </div>
    <div class="trainingCompanies-cards mt-3">
      <b-row>
        <!-- <div class="mb-5 col-4">
            <b-form-input
              v-model="search"
              type="text"
              class="form-input"
              placeholder="بحث عن موظف"

            />
          </div> -->
        <vue3-datatable
          skin="bh-table-bordered "
          paginationInfo=""
          :rows="trainingCompaniesList.training_companies"
          :columns="columns"
          :showPageSize="false"
          :totalRows="trainingCompaniesList.count"
          showNumbers
          pagination
          :isServerMode="true"
          @change="changeServer"
        >
          <template #image="data">
            <div v-if="data.value.image">
              <router-link
                :to="{
                  name: 'show-training-company',
                  params: { id: data.value.id },
                }"
              >
                <img
                  v-if="data.value.image.url"
                  :src="data.value.image.url"
                  width="120"
                />
              </router-link>
            </div>
          </template>
          <template #actions="data">
            <div class="flex gap-4">
              <div class="icon theme-color">
                <i class="fas fa-phone-volume"></i>
              </div>
              <router-link
                :to="{
                  name: 'show-training-company',
                  params: { id: data.value.id },
                }"
              >
                <vue-feather size="16" stroke="blue" type="eye"></vue-feather>
              </router-link>
            </div>
          </template>
          <template #certificates="data">
            <div v-if="data.value.certificates">
              <span v-if="data.value.certificates.length">{{
                data.value.certificates.length
              }}</span>
            </div>
          </template>
        </vue3-datatable>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  name: "TrainingCompaniesList",
  props: {
    trainingCompaniesList: {
      type: Object,
      default: () => {},
    },
    columns: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      search: null,
      APIURL: "companies",
      editComponent: "edit-company",
      viewContent: true,
      type: "page",
    };
  },
  watch: {
    search(newSearch, oldSearch) {
      if (newSearch !== oldSearch) {
        this.$emit("search", newSearch); // Emit the search event to the parent
      }
    },
  },

  computed: {
    filteredTrainingCompanies() {
      // Filter trainingCompanies based on the search input
      if (!this.search) {
        return this.trainingCompaniesList;
      }

      const searchTerm = this.search.toLowerCase();
      return this.trainingCompaniesList.filter((employee) =>
        this.columns.some((column) => {
          const key = column.key;
          const value = employee[key];
          return value && value.toLowerCase().includes(searchTerm);
        })
      );
    },
  },
  methods: {
    changeServer({ current_page }) {
      this.$emit("page-change", current_page);
    },
  },
};
</script>

<style lang=""></style>
